

import store from '../store'
import Request from './request'
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(id,data){
    return Request("get","api/supplier-material-analyze?supplier_id=" + id, data)
}

// material_ids
async function fetchOne(id,data){
    return Request("get","api/supplier-material-analyze?material_ids=" + id, data)
}


// 批量导出
async function batchExport(id,data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/supplier-material-analyze/supplier-material-analyze-export?supplier_id=" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function batchDetailExport(id,data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/supplier-material-analyze/supplier-material-analyze-export?material_ids=" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}


export default {
    fetch,
    fetchOne,
    batchExport,
    batchDetailExport,
}